import styled from 'styled-components';
import { rotate360 } from './animations';

export const Rotate = styled.div`
  display: inline-block;
  animation: ${rotate360} 2s linear infinite;
`;
